import { ToastItem, showToast, TOAST_TIMEOUT_IN_MILLISECONDS } from 'mini-toast';

/**
 * Wrapper to expose a promise to await for when the showToast disappears from the UI
 * @param item ToastItem configuration
 */
export const showToastWithPromise = (item: ToastItem) => {
    let promiseResolve;
    const {
        timeoutInMilliSeconds = TOAST_TIMEOUT_IN_MILLISECONDS,
        label,
        buttonLabel,
        onButtonClick,
    } = item;

    /* tslint:disable:promise-must-complete */
    const promise = new Promise(resolve => {
        promiseResolve = resolve;
        setTimeout(promiseResolve, timeoutInMilliSeconds);
    });
    /* tslint:enable:promise-must-complete */

    showToast({
        label: label, // Localize strings
        onButtonClick: () => {
            // Resolve the promise immediately as the toast will disappear then
            promiseResolve();
            onButtonClick();
        },
        buttonLabel: buttonLabel,
    });
    return promise;
};
